import React from 'react';
import { isViewer, isOperator, roleLabel } from '../lib/roles';
import Icon from './icons';

// Shown on pages that have write actions, so a Viewer/Operator understands
// up front why buttons are hidden/disabled rather than hitting a 403.
export default function RoleBanner({ action, adminOnly = false }) {
  if (!isViewer() && !(adminOnly && isOperator())) return null;

  const message = isViewer()
    ? `You're signed in as ${roleLabel()} — read-only. You won't be able to ${action}.`
    : `You're signed in as ${roleLabel()}. ${action.charAt(0).toUpperCase() + action.slice(1)} requires Admin.`;

  return (
    <div className="role-banner">
      <Icon name="lock" className="role-banner__icon" />
      <span>{message}</span>
    </div>
  );
}
